<template>
  <ListagemBase
    ref="listagem"
    nomePlural="FuncionarioCargos"
    nomeSingular="FuncionarioCargo"
    :headers="headersExibicao"
    :buscaSimplificada="false"
    :buscaParametrizadaPaginada="true"
    :pesquisaDescricao="true"
    :pesquisaStatusComum="!modoSelecaoRecurso"
    :botaoCadastro="!modoSelecaoRecurso"
    :editar="!modoSelecaoRecurso"
    :modoSelecaoRecurso="modoSelecaoRecurso"
    :ocultarCabecalhoListagem="modoSelecaoRecurso"
    :keyboardShortcutsEnabled="!modoSelecaoRecurso"
    :class="{ 'listagem-modo-selecao': modoSelecaoRecurso }"
    @row-click="selecionarRecurso"
  >
  </ListagemBase>
</template>

<script>
import FuncionarioCargoDataService from "@/services/pessoal/FuncionarioCargoDataService";
const DataService = FuncionarioCargoDataService;

import ListagemBase from "@/components/base/Crud/ListagemBase";

export default {
  name: "ListagemFuncionarioCargos",
  components: { ListagemBase },
  props: {
    modoSelecaoRecurso: { type: Boolean, required: false, default: false },
  },
  data() {
    const dataService = this.modoSelecaoRecurso
      ? Object.assign(Object.create(DataService), {
          getPage: (params) =>
            DataService.getFilterPage({ statusComum: "ATIVO" }, params),
          getFilterPage: (payload, params) =>
            DataService.getFilterPage(
              { ...payload, statusComum: "ATIVO" },
              params
            ),
        })
      : DataService;
    return {
      DataService: dataService,

      headers: [
        { text: this.$t("Descricao"), value: "descricao", sortable: "false" },
        { text: this.$t("Status"), value: "statusComum", sortable: "false" },
        { text: this.$t("Salario_base"), value: "salarioBase" },

        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    headersExibicao() {
      return this.modoSelecaoRecurso
        ? this.headers.filter((header) => header.value === "descricao")
        : this.headers;
    },
  },
  methods: {
    selecionarRecurso(payload) {
      if (this.modoSelecaoRecurso && payload && payload.item) {
        this.$emit("selecionar-recurso", payload.item);
      }
    },
  },
};
</script>

<style scoped>
.listagem-modo-selecao::v-deep tbody tr {
  cursor: pointer;
}
</style>
